export class I18nService {
  constructor() {
    this.currentLanguage = localStorage.getItem('tabbly-language') || 'en';
    this.translations = {
      en: {
        'search': 'Search',
        'language': 'Language',
        'callStaff': 'Call Staff',
        'cart': 'Cart',
        'menu.featured': 'Featured',
        'welcome.featuredTitle': 'Our Recommendations',
        'order.confirmTitle': 'Confirm Your Order',
        'order.summaryTitle': 'Order Summary',
        'order.totalLabel': 'Total',
        'order.noModifications': 'No modifications',
        'order.payNow': 'Confirm & Pay Now',
        'order.payLater': 'Confirm (Pay Later)',
        'order.paymentNote': 'You can pay online, at the bar, or with card/cash at the table.',
        'order.selectPaymentMethod': 'Select Payment Method',
        'order.placeOrder': 'Place Order',
        'order.proceedToPayment': 'Proceed to Payment',
        'language.selectTitle': 'Select Language',
        'menu.badge.recommended': 'Recommended',
        'payment.selectMethod': 'Select Payment Method',
        'payment.finishInstruction': 'You have to finish payment to complete the order. You can receive a receipt at the counter or get it electronically.',
        'payment.orderLocked': 'Order placed — items are locked.',
        'payment.noOrderData': 'No order data available',
        'payment.qrMethod': 'QR Code Payment',
        'payment.blikMethod': 'BLIK Code Payment',
        'payment.alternativeOptions': 'Alternative Options',
        'payment.askStaff': 'Ask Staff for Help',
        'payment.askStaffHint': 'A staff member will assist you',
        'payment.payAtCounter': 'Pay at Counter',
        'payment.payAtCounterHint': 'Cash or card accepted at counter',
        'payment.scanQr': 'Scan QR code with your phone to pay',
        'payment.openBankApp': 'Open your banking or payment app and scan the code above',
        'payment.cancelPayment': 'Cancel Payment',
        'payment.blikEnterCode': 'Enter your 6-digit BLIK code',
        'payment.blikGenerate': 'Generate a BLIK code in your banking app',
        'payment.optionalContact': 'Optional: add contact to receive a digital receipt',
        'payment.contactEmailPlaceholder': 'Email',
        'payment.contactPhonePlaceholder': 'Phone',
        'payment.digitalReceiptConsent': 'I agree to receive a digital receipt at the provided contact',
        'payment.submitPayment': 'Submit Payment',
        'payment.cancel': 'Cancel',
        'payment.staffPaymentTitle': 'Staff Payment',
        'payment.counterPaymentTitle': 'Pay at Counter',
        'payment.staffPaymentSubtitle': 'Staff will assist with payment',
        'payment.counterPaymentSubtitle': 'Pay when collecting your order',
        'payment.staffPaymentDescription': 'A staff member has been notified and will come to assist you with payment options.',
        'payment.counterPaymentDescription': 'Please pay at the counter when collecting your order.',
        'payment.staffNotified': 'Staff Notified',
        'payment.orderConfirmed': 'Order Confirmed',
        'payment.waitingForStaff': 'Waiting for Staff',

        'cart.order': 'Order',
        'cart.item': 'item',
        'cart.items': 'items',
        'cart.regular_portion': 'Regular portion',
        'cart.total': 'Total',
        'cart.no_items': 'No items yet',
        'cart.order_awaiting_payment': 'Order Awaiting Payment',
        'cart.complete_payment': 'Complete payment to confirm',
        'cart.order_completed': 'Order Completed',
        'cart.order_confirmed': 'Your order has been confirmed',
        'cart.current_selection': 'Current Selection',
        'cart.unpaid_orders': 'Unpaid Orders',
        'cart.no_unpaid_orders': 'No unpaid orders yet',
        'cart.pay_all': 'Pay All',
        'cart.confirm_order': 'Confirm',
        'cart.continue_payment': 'Continue Payment',
        'cart.cancel_order': 'Cancel Order',
        'cart.view_full_order': 'Confirm',

        'previous': 'Previous',
        'next': 'Next',

        'quantity': 'Quantity',
        'specialInstructions': 'Special Instructions',
        'specialInstructionsPlaceholder': 'Any special requests for this dish?',
        'addToCart': 'Add to Cart',

        'callStaffAssistance': 'Call Staff Assistance',
        'needAssistance': 'Do you need assistance from our staff?',
        'teamMemberNotified': 'A team member will be notified and come to help you shortly.',
        'cancel': 'Cancel',
        'callStaffBtn': 'Call Staff',
        'calling': 'Calling...',
        'staffCalledSuccess': 'Staff Called Successfully!',
        'staffNotified': 'A team member has been notified and will assist you shortly.',
        'ok': 'OK',

        'selectLanguage': 'Select Language',

        'appetizers': 'Appetizers',
        'soups': 'Soups',
        'mains': 'Mains',
        'desserts': 'Desserts',
        'beverages': 'Beverages',
        'sets': 'Sets'
      },
      pl: {
        'search': 'Szukaj',
        'language': 'Język',
        'callStaff': 'Wezwij obsługę',
        'cart': 'Koszyk',
        'menu.featured': 'Wyróżnione',
        'welcome.featuredTitle': 'Polecane przez nas',
        'order.confirmTitle': 'Potwierdź zamówienie',
        'order.summaryTitle': 'Podsumowanie zamówienia',
        'order.totalLabel': 'Razem',
        'order.noModifications': 'Bez modyfikacji',
        'order.payNow': 'Potwierdź i zapłać teraz',
        'order.payLater': 'Potwierdź (zapłacę później)',
        'order.paymentNote': 'Możesz zapłacić online, przy barze lub kartą/gotówką przy stoliku.',
        'order.selectPaymentMethod': 'Wybierz metodę płatności',
        'order.placeOrder': 'Złóż zamówienie',
        'order.proceedToPayment': 'Przejdź do płatności',
        'language.selectTitle': 'Wybierz język',
        'menu.badge.recommended': 'Polecane',
        'payment.selectMethod': 'Wybierz metodę płatności',
        'payment.finishInstruction': 'Aby zakończyć zamówienie, dokończ płatność. Paragon możesz odebrać przy barze lub otrzymać elektronicznie.',
        'payment.orderLocked': 'Zamówienie wysłane — pozycje są zablokowane.',
        'payment.noOrderData': 'Brak danych o zamówieniu',
        'payment.qrMethod': 'Płatność kodem QR',
        'payment.blikMethod': 'Płatność BLIK',
        'payment.alternativeOptions': 'Inne opcje',
        'payment.askStaff': 'Poproś obsługę o pomoc',
        'payment.askStaffHint': 'Członek obsługi zaraz podejdzie',
        'payment.payAtCounter': 'Zapłać przy ladzie',
        'payment.payAtCounterHint': 'Zapłacisz gotówką lub kartą przy ladzie',
        'payment.scanQr': 'Zeskanuj kod QR telefonem, aby zapłacić',
        'payment.openBankApp': 'Otwórz aplikację bankową i zeskanuj powyższy kod',
        'payment.cancelPayment': 'Anuluj płatność',
        'payment.blikEnterCode': 'Wpisz swój 6-cyfrowy kod BLIK',
        'payment.blikGenerate': 'Wygeneruj kod BLIK w aplikacji bankowej',
        'payment.optionalContact': 'Opcjonalnie: podaj dane do e-paragonu',
        'payment.contactEmailPlaceholder': 'E-mail',
        'payment.contactPhonePlaceholder': 'Telefon',
        'payment.digitalReceiptConsent': 'Zgadzam się na otrzymanie e-paragonu na podane dane',
        'payment.submitPayment': 'Wyślij płatność',
        'payment.cancel': 'Anuluj',
        'payment.staffPaymentTitle': 'Płatność z obsługą',
        'payment.counterPaymentTitle': 'Zapłać przy ladzie',
        'payment.staffPaymentSubtitle': 'Obsługa pomoże Ci z płatnością',
        'payment.counterPaymentSubtitle': 'Zapłać przy odbiorze zamówienia',
        'payment.staffPaymentDescription': 'Obsługa została powiadomiona i wkrótce podejdzie z terminalem.',
        'payment.counterPaymentDescription': 'Zapłać przy ladzie podczas odbioru zamówienia.',
        'payment.staffNotified': 'Obsługa powiadomiona',
        'payment.orderConfirmed': 'Zamówienie potwierdzone',
        'payment.waitingForStaff': 'Czekaj na obsługę',

        'cart.order': 'Zamówienie',
        'cart.item': 'pozycja',
        'cart.items': 'pozycje',
        'cart.regular_portion': 'Porcja standardowa',
        'cart.total': 'Razem',
        'cart.no_items': 'Brak pozycji',
        'cart.order_awaiting_payment': 'Zamówienie oczekuje na płatność',
        'cart.complete_payment': 'Dokończ płatność, aby potwierdzić',
        'cart.order_completed': 'Zamówienie zrealizowane',
        'cart.order_confirmed': 'Twoje zamówienie zostało potwierdzone',
        'cart.current_selection': 'Bieżące zamówienie',
        'cart.unpaid_orders': 'Niezapłacone zamówienia',
        'cart.no_unpaid_orders': 'Brak niezapłaconych zamówień',
        'cart.pay_all': 'Zapłać wszystko',
        'cart.confirm_order': 'Potwierdź',
        'cart.continue_payment': 'Kontynuuj płatność',
        'cart.cancel_order': 'Anuluj zamówienie',
        'cart.view_full_order': 'Potwierdź',

        'previous': 'Poprzedni',
        'next': 'Następny',

        'quantity': 'Ilość',
        'specialInstructions': 'Uwagi specjalne',
        'specialInstructionsPlaceholder': 'Jakieś specjalne życzenia do tego dania?',
        'addToCart': 'Dodaj do koszyka',

        'callStaffAssistance': 'Wezwij obsługę',
        'needAssistance': 'Czy potrzebujesz pomocy naszej obsługi?',
        'teamMemberNotified': 'Członek zespołu zostanie powiadomiony i niedługo przyjdzie Ci pomóc.',
        'cancel': 'Anuluj',
        'callStaffBtn': 'Wezwij obsługę',
        'calling': 'Wzywam...',
        'staffCalledSuccess': 'Obsługa została wezwana!',
        'staffNotified': 'Członek zespołu został powiadomiony i niedługo Ci pomoże.',
        'ok': 'OK',

        'selectLanguage': 'Wybierz język',

        'appetizers': 'Przystawki',
        'soups': 'Zupy',
        'mains': 'Dania główne',
        'desserts': 'Desery',
        'beverages': 'Napoje',
        'sets': 'Zestawy'
      },
      es: {
        'search': 'Buscar',
        'language': 'Idioma',
        'callStaff': 'Llamar personal',
        'cart': 'Carrito',
        'menu.featured': 'Destacados',
        'welcome.featuredTitle': 'Recomendado por nosotros',
        'order.confirmTitle': 'Confirma tu pedido',
        'order.summaryTitle': 'Resumen del pedido',
        'order.totalLabel': 'Total',
        'order.noModifications': 'Sin modificaciones',
        'order.payNow': 'Confirmar y pagar ahora',
        'order.payLater': 'Confirmar (pagaré después)',
        'order.paymentNote': 'Puedes pagar online, en la barra o con tarjeta/efectivo en la mesa.',
        'order.selectPaymentMethod': 'Selecciona el método de pago',
        'order.placeOrder': 'Realizar pedido',
        'order.proceedToPayment': 'Ir al pago',
        'language.selectTitle': 'Selecciona el idioma',
        'menu.badge.recommended': 'Recomendado',
        'payment.selectMethod': 'Selecciona el método de pago',
        'payment.finishInstruction': 'Debes finalizar el pago para completar el pedido. Puedes recibir el recibo en la barra o electrónicamente.',
        'payment.orderLocked': 'Pedido enviado: los artículos están bloqueados.',
        'payment.noOrderData': 'No hay datos del pedido disponibles',
        'payment.qrMethod': 'Pago con código QR',
        'payment.blikMethod': 'Pago con código BLIK',
        'payment.alternativeOptions': 'Opciones alternativas',
        'payment.askStaff': 'Pedir ayuda al personal',
        'payment.askStaffHint': 'Un miembro del personal te ayudará',
        'payment.payAtCounter': 'Pagar en el mostrador',
        'payment.payAtCounterHint': 'Se acepta efectivo o tarjeta en el mostrador',
        'payment.scanQr': 'Escanea el código QR con tu teléfono para pagar',
        'payment.openBankApp': 'Abre tu app bancaria o de pagos y escanea el código',
        'payment.cancelPayment': 'Cancelar pago',
        'payment.blikEnterCode': 'Ingresa tu código BLIK de 6 dígitos',
        'payment.blikGenerate': 'Genera un código BLIK en tu app bancaria',
        'payment.optionalContact': 'Opcional: añade contacto para recibir el recibo digital',
        'payment.contactEmailPlaceholder': 'Correo electrónico',
        'payment.contactPhonePlaceholder': 'Teléfono',
        'payment.digitalReceiptConsent': 'Acepto recibir un recibo digital en los datos proporcionados',
        'payment.submitPayment': 'Enviar pago',
        'payment.cancel': 'Cancelar',
        'payment.staffPaymentTitle': 'Pago con personal',
        'payment.counterPaymentTitle': 'Pagar en el mostrador',
        'payment.staffPaymentSubtitle': 'El personal te ayudará con el pago',
        'payment.counterPaymentSubtitle': 'Paga al recoger tu pedido',
        'payment.staffPaymentDescription': 'Se ha avisado al personal y acudirán para ayudarte con el pago.',
        'payment.counterPaymentDescription': 'Paga en el mostrador cuando recojas tu pedido.',
        'payment.staffNotified': 'Personal avisado',
        'payment.orderConfirmed': 'Pedido confirmado',
        'payment.waitingForStaff': 'Esperando al personal',

        'cart.order': 'Pedido',
        'cart.item': 'artículo',
        'cart.items': 'artículos',
        'cart.regular_portion': 'Porción regular',
        'cart.total': 'Total',
        'cart.no_items': 'No hay artículos aún',
        'cart.order_awaiting_payment': 'Pedido pendiente de pago',
        'cart.complete_payment': 'Completa el pago para confirmar',
        'cart.order_completed': 'Pedido completado',
        'cart.order_confirmed': 'Tu pedido ha sido confirmado',
        'cart.current_selection': 'Selección actual',
        'cart.unpaid_orders': 'Pedidos sin pagar',
        'cart.no_unpaid_orders': 'No hay pedidos sin pagar',
        'cart.pay_all': 'Pagar todo',
        'cart.confirm_order': 'Confirmar',
        'cart.continue_payment': 'Continuar pago',
        'cart.cancel_order': 'Cancelar pedido',
        'cart.view_full_order': 'Confirmar',

        'previous': 'Anterior',
        'next': 'Siguiente',

        'quantity': 'Cantidad',
        'specialInstructions': 'Instrucciones especiales',
        'specialInstructionsPlaceholder': '¿Alguna solicitud especial para este plato?',
        'addToCart': 'Añadir al carrito',

        'callStaffAssistance': 'Llamar asistencia del personal',
        'needAssistance': '¿Necesitas asistencia de nuestro personal?',
        'teamMemberNotified': 'Un miembro del equipo será notificado y vendrá a ayudarte en breve.',
        'cancel': 'Cancelar',
        'callStaffBtn': 'Llamar personal',
        'calling': 'Llamando...',
        'staffCalledSuccess': '¡Personal llamado exitosamente!',
        'staffNotified': 'Un miembro del equipo ha sido notificado y te ayudará en breve.',
        'ok': 'OK',

        'selectLanguage': 'Seleccionar idioma',

        'appetizers': 'Aperitivos',
        'soups': 'Sopas',
        'mains': 'Platos principales',
        'desserts': 'Postres',
        'beverages': 'Bebidas',
        'sets': 'Menús'
      },
      de: {
        'search': 'Suchen',
        'language': 'Sprache',
        'callStaff': 'Personal rufen',
        'cart': 'Warenkorb',
        'menu.featured': 'Empfohlen',
        'welcome.featuredTitle': 'Unsere Empfehlungen',
        'order.confirmTitle': 'Bestätige deine Bestellung',
        'order.summaryTitle': 'Bestellübersicht',
        'order.totalLabel': 'Gesamt',
        'order.noModifications': 'Keine Anpassungen',
        'order.payNow': 'Jetzt bestätigen und bezahlen',
        'order.payLater': 'Bestätigen (später bezahlen)',
        'order.paymentNote': 'Du kannst online, an der Bar oder mit Karte/Barzahlung am Tisch bezahlen.',
        'order.selectPaymentMethod': 'Zahlungsmethode wählen',
        'order.placeOrder': 'Bestellung abschicken',
        'order.proceedToPayment': 'Zur Zahlung fortfahren',
        'language.selectTitle': 'Sprache wählen',
        'menu.badge.recommended': 'Empfohlen',
        'payment.selectMethod': 'Zahlungsmethode wählen',
        'payment.finishInstruction': 'Bitte schließe die Zahlung ab, um die Bestellung zu vollenden. Die Quittung erhältst du an der Bar oder digital.',
        'payment.orderLocked': 'Bestellung gesendet – Artikel sind gesperrt.',
        'payment.noOrderData': 'Keine Bestelldaten verfügbar',
        'payment.qrMethod': 'QR-Code-Zahlung',
        'payment.blikMethod': 'BLIK-Zahlung',
        'payment.alternativeOptions': 'Alternative Optionen',
        'payment.askStaff': 'Personal um Hilfe bitten',
        'payment.askStaffHint': 'Ein Teammitglied hilft dir gleich weiter',
        'payment.payAtCounter': 'Am Tresen bezahlen',
        'payment.payAtCounterHint': 'Bar oder Karte am Tresen möglich',
        'payment.scanQr': 'Scanne den QR-Code mit deinem Smartphone, um zu bezahlen',
        'payment.openBankApp': 'Öffne deine Banking- oder Zahlungs-App und scanne den Code',
        'payment.cancelPayment': 'Zahlung abbrechen',
        'payment.blikEnterCode': 'Gib deinen 6-stelligen BLIK-Code ein',
        'payment.blikGenerate': 'Erzeuge einen BLIK-Code in deiner Banking-App',
        'payment.optionalContact': 'Optional: Kontakt angeben, um eine elektronische Quittung zu erhalten',
        'payment.contactEmailPlaceholder': 'E-Mail',
        'payment.contactPhonePlaceholder': 'Telefon',
        'payment.digitalReceiptConsent': 'Ich möchte eine elektronische Quittung an die angegebenen Daten erhalten',
        'payment.submitPayment': 'Zahlung senden',
        'payment.cancel': 'Abbrechen',
        'payment.staffPaymentTitle': 'Zahlung mit Personal',
        'payment.counterPaymentTitle': 'Am Tresen bezahlen',
        'payment.staffPaymentSubtitle': 'Das Personal unterstützt dich bei der Zahlung',
        'payment.counterPaymentSubtitle': 'Bezahle beim Abholen deiner Bestellung',
        'payment.staffPaymentDescription': 'Das Personal wurde benachrichtigt und kommt gleich mit einem Terminal.',
        'payment.counterPaymentDescription': 'Bitte bezahle am Tresen, wenn du dein Essen abholst.',
        'payment.staffNotified': 'Personal benachrichtigt',
        'payment.orderConfirmed': 'Bestellung bestätigt',
        'payment.waitingForStaff': 'Warte auf das Personal',

        'cart.order': 'Bestellung',
        'cart.item': 'Artikel',
        'cart.items': 'Artikel',
        'cart.regular_portion': 'Normale Portion',
        'cart.total': 'Gesamt',
        'cart.no_items': 'Noch keine Artikel',
        'cart.order_awaiting_payment': 'Bestellung wartet auf Zahlung',
        'cart.complete_payment': 'Zahlung abschließen, um zu bestätigen',
        'cart.order_completed': 'Bestellung abgeschlossen',
        'cart.order_confirmed': 'Deine Bestellung wurde bestätigt',
        'cart.current_selection': 'Aktuelle Auswahl',
        'cart.unpaid_orders': 'Offene Bestellungen',
        'cart.no_unpaid_orders': 'Keine offenen Bestellungen',
        'cart.pay_all': 'Alles bezahlen',
        'cart.confirm_order': 'Bestätigen',
        'cart.continue_payment': 'Zahlung fortsetzen',
        'cart.cancel_order': 'Bestellung stornieren',
        'cart.view_full_order': 'Bestätigen',

        'previous': 'Vorherige',
        'next': 'Nächste',

        'quantity': 'Menge',
        'specialInstructions': 'Besondere Wünsche',
        'specialInstructionsPlaceholder': 'Haben Sie besondere Wünsche für dieses Gericht?',
        'addToCart': 'In den Warenkorb',

        'callStaffAssistance': 'Personal-Hilfe rufen',
        'needAssistance': 'Benötigen Sie Hilfe von unserem Personal?',
        'teamMemberNotified': 'Ein Teammitglied wird benachrichtigt und kommt Ihnen in Kürze zu Hilfe.',
        'cancel': 'Abbrechen',
        'callStaffBtn': 'Personal rufen',
        'calling': 'Rufe...',
        'staffCalledSuccess': 'Personal erfolgreich gerufen!',
        'staffNotified': 'Ein Teammitglied wurde benachrichtigt und wird Ihnen in Kürze helfen.',
        'ok': 'OK',

        'selectLanguage': 'Sprache auswählen',

        'appetizers': 'Vorspeisen',
        'soups': 'Suppen',
        'mains': 'Hauptgerichte',
        'desserts': 'Nachspeisen',
        'beverages': 'Getränke',
        'sets': 'Menüs'
      }
    };
  }

  t(key) {
    return this.translations[this.currentLanguage]?.[key] || this.translations['en']?.[key] || key;
  }

  tForLanguage(key, language) {
    if (!language) {
      return this.t(key);
    }
    return this.translations[language]?.[key] || this.translations['en']?.[key] || key;
  }

  setLanguage(language) {
    if (this.translations[language] && this.currentLanguage !== language) {
      this.currentLanguage = language;
      localStorage.setItem('tabbly-language', language);

      const event = new CustomEvent('languageChanged', {
        detail: { language: language }
      });
      document.dispatchEvent(event);
    }
  }

  getCurrentLanguage() {
    return this.currentLanguage;
  }

  getAvailableLanguages() {
    return Object.keys(this.translations);
  }
}
